import { useMemo } from 'react';
import { Formik, Form } from 'formik';
import { useToggle } from '@packlink/utils';
import { IconNames } from '@shipengine/giger-theme';
import { Button, ButtonVariant, Icon } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { AmplitudeEvents, ProviderName } from '@packlink/metrics';
import { getButtonSidePanelFiltersStyles } from './SidePanelFiltersStyles.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { useFiltersStructure } from '../../hooks/useFiltersStructure.js';
import { FiltersForm } from './FiltersForm/FiltersForm.js';
import { useSendMetrics } from '../MetricsProvider/useSendMetrics.js';
import { useFiltersValues } from '../../hooks/useFiltersValues.js';
import { getLengthValues } from '../../utils/Filters.js';

const SidePanelFilters = _ref => {
  let {
    containerId,
    services,
    selectedFilters,
    debugMode,
    onChangeFilters
  } = _ref;
  const {
    t
  } = useTranslation();
  const sendMetrics = useSendMetrics();
  const {
    state: isSidePanelOpen,
    toggle: toggleSidePanel
  } = useToggle(false);
  const filterStructure = useFiltersStructure(services, debugMode);
  const initialValues = useFiltersValues(filterStructure, selectedFilters);
  const isFiltersButtonActive = Object.values(filterStructure).find(filter => filter.length > 1);
  const totalSelectedFilters = useMemo(() => {
    if (!selectedFilters) {
      return 0;
    }
    return getLengthValues({
      ...selectedFilters.carriers,
      ...selectedFilters.collectionTypes,
      ...selectedFilters.deliveryTypes,
      ...selectedFilters.transitHours,
      ...selectedFilters.serviceDetails,
      ...selectedFilters.tagTypes
    });
  }, [selectedFilters]);
  const handleClickFilter = () => {
    const event = totalSelectedFilters ? AmplitudeEvents.SERVICE_LIST_EDIT_FILTERS : AmplitudeEvents.SERVICE_LIST_OPEN_FILTERS;
    sendMetrics({
      providerName: ProviderName.AMPLITUDE,
      eventName: event
    });
    toggleSidePanel();
  };
  const onSubmit = (values, formikHelpers) => {
    onChangeFilters(values);
    toggleSidePanel();
    formikHelpers.setSubmitting(false);
  };
  return jsxs(Fragment, {
    children: [jsx("div", {
      css: getButtonSidePanelFiltersStyles,
      children: jsxs(Button, {
        variant: ButtonVariant.TEXT,
        onClick: handleClickFilter,
        "data-id": "button-side-open",
        disabled: !isFiltersButtonActive,
        children: [jsx("span", {
          children: totalSelectedFilters && isFiltersButtonActive ? `${t('service-list.button.edit-filters')} (${totalSelectedFilters}) ` : t('service-list.button.filters')
        }), jsx(Icon, {
          name: IconNames.FILTER
        })]
      })
    }), isFiltersButtonActive && jsx(Formik, {
      onSubmit: onSubmit,
      initialValues: initialValues,
      enableReinitialize: true,
      children: jsx(Form, {
        children: jsx(FiltersForm, {
          containerId: containerId,
          filters: filterStructure,
          isSidePanelOpen: isSidePanelOpen,
          toggleSidePanel: toggleSidePanel,
          selectedFilters: selectedFilters,
          services: services
        })
      })
    })]
  });
};
SidePanelFilters.displayName = 'SidePanelFilters';

export { SidePanelFilters, SidePanelFilters as default };
//# sourceMappingURL=SidePanelFilters.js.map
